import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { SCREENS } from '../../constants/tracking/Screens';
import { jsx as _jsx } from "react/jsx-runtime";
const productsConfig = {
  STARTER: {
    apiName: Products.OPERATIONS_HUB_STARTER,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.starterCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(StarterLowerTierMessage, {})
  },
  PROFESSIONAL: {
    apiName: Products.OPERATIONS_HUB_PROFESSIONAL,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.professionalCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.professional.lowerTierPlus"
    })
  },
  ENTERPRISE: {
    apiName: Products.OPERATIONS_HUB_ENTERPRISE,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.data.enterpriseCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.enterprise.lowerTierPlus"
    })
  }
};
export const DataHubMerchCards = () => {
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig,
    screen: SCREENS.DATA
  });
};